export default {"src":"/_next/static/media/wind-surfing.34b25bda.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};